import { useMemo } from "react";
import { useAppContext } from "../context/AuthContext";
export default function LabelsContext() {
  const { t } = useAppContext();
  const Labels = useMemo(() => {
    return {
      ENGLISH: t("ENGLISH"),
      RHNILOGY_REVIEW_SYSTEM: t("RHNILOGY_REVIEW_SYSTEM"),
      EMAIL: t("EMAIL"),
      EMAIL_ADDRESS: t("EMAIL_ADDRESS"),
      ORDER: t("ORDER"),
      PASSWORD: t("PASSWORD"),
      LOGIN: t("LOGIN"),
      LOGIN_AS: t("LOGIN_AS"),
      LOGOUT: t("LOGOUT"),
      REGISTRATION: t("REGISTRATION"),
      FORGOT_PASSWORD: t("FORGOT_PASSWORD"),
      CANCEL: t("CANCEL"),
      REGISTER: t("REGISTER"),
      FIRSTNAME: t("FIRSTNAME"),
      MIDDLENAME: t("MIDDLENAME"),
      LASTNAME: t("LASTNAME"),
      ORCID: t("ORCID"),
      TITLE: t("TITLE"),
      DEPARTMENT: t("DEPARTMENT"),
      DIVISION: t("DIVISION"),
      INSTITUTE: t("INSTITUTE"),
      COUNTRY: t("COUNTRY"),
      CITY: t("CITY"),
      STREET_NAME: t("STREET_NAME"),
      POSTAL_CODE: t("POSTAL_CODE"),
      PHONE_NUMBER: t("PHONE_NUMBER"),
      REPEAT_EMAIL_ADDRESS: t("REPEAT_EMAIL_ADDRESS"),
      REPEAT_PASSWORD: t("REPEAT_PASSWORD"),
      AREAS_OF_EXPERTISE: t("AREAS_OF_EXPERTISE"),
      PROFILE: t("PROFILE"),
      SAVE: t("SAVE"),
      ORCID_MASK: t("ORCID_MASK"),
      FIRSTNAME_REQUIRED: t("FIRSTNAME_REQUIRED"),
      FULLNAME_REQUIRED: t("FULLNAME_REQUIRED"),
      MAILTO_REQUIRED: t("MAILTO_REQUIRED"),
      LASTNAME_REQUIRED: t("LASTNAME_REQUIRED"),
      ORCID_REQUIRED: t("ORCID_REQUIRED"),
      EMAIL_REQUIRED: t("EMAIL_REQUIRED"),
      EMAIL_REPEAT_REQUIRED: t("EMAIL_REPEAT_REQUIRED"),
      PASSWORD_REQUIRED: t("PASSWORD_REQUIRED"),
      PASSWORD_REPEAT_REQUIRED: t("PASSWORD_REPEAT_REQUIRED"),
      TITLE_REQUIRED: t("TITLE_REQUIRED"),
      EMAIL_DO_NOT_MATCH: t("EMAIL_DO_NOT_MATCH"),
      PASSWORDS_DO_NOT_MATCH: t("PASSWORDS_DO_NOT_MATCH"),
      PLACEHOLDER_POSTAL_CODE: t("PLACEHOLDER_POSTAL_CODE"),
      PLACEHOLDER_WRITE_COMMENT: t("PLACEHOLDER_WRITE_COMMENT"),
      MANUSCRIPTS: t("MANUSCRIPTS"),
      VIEW: t("VIEW"),
      DRAFT: t("DRAFT"),
      SUBMIT: t("SUBMIT"),
      TICKETS: t("TICKETS"),
      REVIEW_HISTORY: t("REVIEW_HISTORY"),
      TO_DO_LIST: t("TO_DO_LIST"),
      AUTHOR: t("AUTHOR"),
      AUTHORS: t("AUTHORS"),
      REVIEWER: t("REVIEWER"),
      REVIEWERS: t("REVIEWERS"),
      PAPER_FILES: t("PAPER_FILES"),
      OVERVIEW: t("OVERVIEW"),
      BACK: t("BACK"),
      RESET: t("RESET"),
      FINISHED_STEPPER: t("FINISHED_STEPPER"),
      FINISH: t("FINISH"),
      NEXT: t("NEXT"),
      UNKNOWN_STEP: t("UNKNOWN_STEP"),
      REGISTER_SUCCESS: t("REGISTER_SUCCESS"),
      EDIT_USER_SUCCESS: t("EDIT_USER_SUCCESS"),
      SUCCESSFULLY_ADDED: t("SUCCESSFULLY_ADDED"),
      SUCCESSFULLY_DELETED: t("SUCCESSFULLY_DELETED"),
      SUCCESSFULLY_UPDATED: t("SUCCESSFULLY_UPDATED"),
      TABLES: t("TABLES"),
      GENERAL_INFORMATION: t("GENERAL_INFORMATION"),
      COVER_LETTER: t("COVER_LETTER"),
      FIRST_TIME_CLASSIFICATION: t("FIRST_TIME_CLASSIFICATION"),
      FIRST_TIME: t("FIRST_TIME"),
      PREVIOUS_ID: t("PREVIOUS_ID"),
      KEYWORDS: t("KEYWORDS"),
      ALL_KEYWORDS: t("ALL_KEYWORDS"),
      SELECTED_KEYWORDS: t("SELECTED_KEYWORDS"),
      ABSTRACT: t("ABSTRACT"),
      COPY_ITEMS: t("COPY_ITEMS"),
      YES: t("YES"),
      NO: t("NO"),
      ADD: t("ADD"),
      EDIT: t("EDIT"),
      CHANGE_GROUP: t("CHANGE_GROUP"),
      REMOVE: t("REMOVE"),
      SEARCH: t("SEARCH"),
      ADDED_AUTHORS: t("ADDED_AUTHORS"),
      RESULTS: t("RESULTS"),
      SEARCH_AUTHOR: t("SEARCH_AUTHOR"),
      REVIEWER_1_NAME: t("REVIEWER_1_NAME"),
      REVIEWER_2_NAME: t("REVIEWER_2_NAME"),
      EXCLUDED: t("EXCLUDED"),
      REVIEWER_1: t("REVIEWER_1"),
      REVIEWER_2: t("REVIEWER_2"),
      REVIEWER_EXCLUDED: t("REVIEWER_EXCLUDED"),
      REVIEWER_1_RELATIONSHIP: t("REVIEWER_1_RELATIONSHIP"),
      REVIEWER_2_RELATIONSHIP: t("REVIEWER_2_RELATIONSHIP"),
      UPDATE: t("UPDATE"),
      FILTER: t("FILTER"),
      NO_RESULTS: t("NO_RESULTS"),
      NOTE: t("NOTE"),
      MANUSCRIPT_FIGURES: t("MANUSCRIPT_FIGURES"),
      NAME: t("NAME"),
      STATUS: t("STATUS"),
      DELETE: t("DELETE"),
      SUBJECT: t("SUBJECT"),
      SUBJECT_PLACEHOLDER: t("SUBJECT_PLACEHOLDER"),
      TICKET_HELP: t("TICKET_HELP"),
      NEW_TICKET_HELP: t("NEW_TICKET_HELP"),
      NEW_TICKET: t("NEW_TICKET"),
      ADD_KEYWORD: t("ADD_KEYWORD"),
      SEARCH_KEYWORD: t("SEARCH_KEYWORD"),
      SEND: t("SEND"),
      EDITOR: t("EDITOR"),
      ALL_MANUSCRIPT: t("ALL_MANUSCRIPT"),
      MY_MANUSCRIPT: t("MY_MANUSCRIPT"),
      ACTIVE_MANUSCRIPT: t("ACTIVE_MANUSCRIPT"),
      ARCHIVE: t("ARCHIVE"),
      ALL_REVIEWERS: t("ALL_REVIEWERS"),
      KEYWORD: t("KEYWORD"),
      USERS: t("USERS"),
      REVIEWERS_STATISTICS: t("REVIEWERS_STATISTICS"),
      ASSOCIATE_STATISTICS: t("ASSOCIATE_STATISTICS"),
      ASSISTANT_EDITOR: t("ASSISTANT_EDITOR"),
      ACCEPTED_MANUSCRIPTS: t("ACCEPTED_MANUSCRIPTS"),
      SEARCH_MANUSCRIPTS: t("SEARCH_MANUSCRIPTS"),
      BLACKLIST_AUTHORS: t("BLACKLIST_AUTHORS"),
      ALL_ASSOCIATE_EDITORS: t("ALL_ASSOCIATE_EDITORS"),
      CLOSE: t("CLOSE"),
      AWAITING_RESPONSE: t("AWAITING_RESPONSE"),
      OPEN: t("OPEN"),
      CLOSED: t("CLOSED"),
      BUG: t("BUG"),
      REQUEST: t("REQUEST"),
      GENERAL: t("GENERAL"),
      QUESTION_CLOSE_TICKET: t("QUESTION_CLOSE_TICKET"),
      CLOSED_TICKET: t("CLOSED_TICKET"),
      DIALOG_ERROR: t("DIALOG_ERROR"),
      PENDING_TICKETS: t("PENDING_TICKETS"),
      TICKETS_ANSWERING: t("TICKETS_ANSWERING"),
      TICKET: t("TICKET"),
      TYPE: t("TYPE"),
      NAME_REQUIRED: t("NAME_REQUIRED"),
      CONTENT_REQUIRED: t("CONTENT_REQUIRED"),
      TYPE_REQUIRED: t("TYPE_REQUIRED"),
      FILE_NAME: t("FILE_NAME"),
      FILE_DESIGNATION: t("FILE_DESIGNATION"),
      FILE_TYPE: t("FILE_TYPE"),
      FILE_UPLOAD: t("FILE_UPLOAD"),
      SIZE: t("SIZE"),
      COMMENTS: t("COMMENTS"),
      UPLOAD: t("UPLOAD"),
      UPLOAD_BY_USER: t("UPLOAD_BY_USER"),
      MANUSCRIPT: t("MANUSCRIPT"),
      FIGURE: t("FIGURE"),
      SUPPLEMENTARY_FIGURE: t("SUPPLEMENTARY_FIGURE"),
      ADDITIONAL_FILE: t("ADDITIONAL_FILE"),
      VIDEO_FILE: t("VIDEO_FILE"),
      YOU_WANT_TO_MOVE_ON: t("YOU_WANT_TO_MOVE_ON"),
      PICTURE_IS_UPLOADED: t("PICTURE_IS_UPLOADED"),
      RELATIONSHIP: t("RELATIONSHIP"),
      MANUSCRIPT_CLASSIFICATION: t("MANUSCRIPT_CLASSIFICATION"),
      EDIT_KEYWORD: t("EDIT_KEYWORD"),
      NEW_KEYWORD: t("NEW_KEYWORD"),
      ARTICLE_NUMBER: t("ARTICLE_NUMBER"),
      REVISION_NUMBER: t("REVISION_NUMBER"),
      SHORT_REASON: t("SHORT_REASON"),
      ROLE: t("ROLE"),
      DETAILS: t("DETAILS"),
      ADD_REVIEWER: t("ADD_REVIEWER"),
      GROUPS: t("GROUPS"),
      EDIT_USER: t("EDIT_USER"),
      EXPERTISE: t("EXPERTISE"),
      UPDATE_AREAS_OF_EXPERTISE: t("UPDATE_AREAS_OF_EXPERTISE"),
      RENAME: t("RENAME"),
      REVIEW_STATUS: t("REVIEW_STATUS"),
      AUTHOR_FIRSTNAME: t("AUTHOR_FIRSTNAME"),
      AUTHOR_LASTNAME: t("AUTHOR_LASTNAME"),
      ARTICLE_ID: t("ARTICLE_ID"),
      NEW_ARTICLE: t("NEW_ARTICLE"),
      REJECTED: t("REJECTED"),
      ACCEPTED: t("ACCEPTED"),
      MAJOR_REVISION: t("MAJOR_REVISION"),
      MINOR_REVISION: t("MINOR_REVISION"),
      REVIEWED: t("REVIEWED"),
      UNDER_REVIEW: t("UNDER_REVIEW"),
      REVIEWER_SELECTION: t("REVIEWER_SELECTION"),
      DIRECT_REJECT: t("DIRECT_REJECT"),
      CORRECTION: t("CORRECTION"),
      REJECTED_R0: t("REJECTED_R0"),
      DIRECT_REJECT_R0: t("DIRECT_REJECT_R0"),
      REJECT_AND_RESUBMIT_AS_A_LETTER_TO_THE_EDITOR: t("REJECT_AND_RESUBMIT_AS_A_LETTER_TO_THE_EDITOR"),
      ASSOCIATE_EDITOR: t("ASSOCIATE_EDITOR"),
      RETURNED_TO_EDITOR: t("RETURNED_TO_EDITOR"),
      ASSOC_EDITOR: t("ASSOC_EDITOR"),
      ASSOC_EDITOR_DECISION: t("ASSOC_EDITOR_DECISION"),
      SUBMITTED_ON: t("SUBMITTED_ON"),
      LAST_UPDATE: t("LAST_UPDATE"),
      FULL_ARTICLE: t("FULL_ARTICLE"),
      FULL: t("FULL"),
      ORIGINAL_FILES: t("ORIGINAL_FILES"),
      ORIGINAL: t("ORIGINAL"),
      COVER: t("COVER"),
      RESPONSE_TIME: t("RESPONSE_TIME"),
      COMPLETED: t("COMPLETED"),
      REFUSED: t("REFUSED"),
      REFUSED_PERCENTAGE: t("REFUSED_PERCENTAGE"),
      RATING: t("RATING"),
      DATE: t("DATE"),
      DATE_FROM: t("DATE_FROM"),
      DATE_TO: t("DATE_TO"),
      ACTION: t("ACTION"),
      OVERRIDE: t("OVERRIDE"),
      ASSIGN_REVIEWERS: t("ASSIGN_REVIEWERS"),
      DECIDE_ON_STATUS: t("DECIDE_ON_STATUS"),
      OVERDUE_REVIEWERS: t("OVERDUE_REVIEWERS"),
      OVERDUE_AES: t("OVERDUE_AES"),
      REQUIRED_REVIEWERS: t("REQUIRED_REVIEWERS"),
      ASSIGNED_REVIEWERS: t("ASSIGNED_REVIEWERS"),
      ASSIGN_NEW_REVIEWERS: t("ASSIGN_NEW_REVIEWERS"),
      LETTER_TO_THE_EDITOR: t("LETTER_TO_THE_EDITOR"),
      TO_ASSOCIATE_EDITOR: t("TO_ASSOCIATE_EDITOR"),
      MAIL_ALL: t("MAIL_ALL"),
      ACTIVE: t("ACTIVE"),
      INACTIVE: t("INACTIVE"),
      CUSTOM: t("CUSTOM"),
      MAKE_DECISION: t("MAKE_DECISION"),
      SEND_MAIL_TO_ALL: t("SEND_MAIL_TO_ALL"),
      SEND_MAIL: t("SEND_MAIL"),
      MAIL_SENT: t("MAIL_SENT"),
      TO: t("TO"),
      CC: t("CC"),
      MESSAGE: t("MESSAGE"),
      NEW_EMAIL: t("NEW_EMAIL"),
      SEND_THANKS_CHANGE_STATUS: t("SEND_THANKS_CHANGE_STATUS"),
      CURRENT_ASSIGNMENTS: t("CURRENT_ASSIGNMENTS"),
      ASSIGNMENTS_LAST_YEAR: t("ASSIGNMENTS_LAST_YEAR"),
      COMPLETED_LAST_YEAR: t("COMPLETED_LAST_YEAR"),
      RESPONSE_TIME_DAYS: t("RESPONSE_TIME_DAYS"),
      PUBLISHED_LAST_36_MONTHS: t("PUBLISHED_LAST_36_MONTHS"),
      ACTIVE_ASSIGNMENTS: t("ACTIVE_ASSIGNMENTS"),
      SELECT_STATUS: t("SELECT_STATUS"),
      MAILTO: t("MAILTO"),
      ARTICLE_STATUS: t("ARTICLE_STATUS"),
      CHECK_MANUSCRIPT: t("CHECK_MANUSCRIPT"),
      REJECT: t("REJECT"),
      ACCEPT: t("ACCEPT"),
      DECLINE: t("DECLINE"),
      REVIEW: t("REVIEW"),
      REVIEW_REQUESTS: t("REVIEW_REQUESTS"),
      PENDING_REVIEWS: t("PENDING_REVIEWS"),
      NOTES: t("NOTES"),
      LOG: t("LOG"),
      EMAIL_LOG: t("EMAIL_LOG"),
      REVIEWS: t("REVIEWS"),
      ARTICLE_DETAILS: t("ARTICLE_DETAILS"),
      REVISION: t("REVISION"),
      SELECTED_ON: t("SELECTED_ON"),
      MAILED_ON: t("MAILED_ON"),
      DECIDED_ON: t("DECIDED_ON"),
      COMPLETED_ON: t("COMPLETED_ON"),
      NO_REVIEWERS_REVISION: t("NO_REVIEWERS_REVISION"),
      ADJUST_MANUSCRIPT: t("ADJUST_MANUSCRIPT"),
      UPLOAD_REVISION: t("UPLOAD_REVISION"),
      INSTRUCTIONS: t("INSTRUCTIONS"),
      MANUSCRIPT_INFORMATION: t("MANUSCRIPT_INFORMATION"),
      REVISION_UPLOAD: t("REVISION_UPLOAD"),
      FULLNAME: t("FULLNAME"),
      SUGGEST_REVIEWER: t("SUGGEST_REVIEWER"),
      SENIOR: t("SENIOR"),
      MEDIOR: t("MEDIOR"),
      JUNIOR: t("JUNIOR"),
      SENIORITY: t("SENIORITY"),
      STATUS_CHANGE: t("STATUS_CHANGE"),
      REVIEWER_ASSIGNMENT: t("REVIEWER_ASSIGNMENT"),
      REVIEWER_ASSIGNMENT_REMOVED: t("REVIEWER_ASSIGNMENT_REMOVED"),
      REVIEWER_MAILED: t("REVIEWER_MAILED"),
      REVIEWER_ANSWER: t("REVIEWER_ANSWER"),
      REVIEWER_DECISION: t("REVIEWER_DECISION"),
      AE_ASSIGNMENT: t("AE_ASSIGNMENT"),
      AE_DECISION: t("AE_DECISION"),
      ASSISTANT_DECISION: t("ASSISTANT_DECISION"),
      EDITOR_DECISION: t("EDITOR_DECISION"),
    };
  }, [t]);
  return { Labels };
}
